// src/components/SignUp.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import signupImage from "../assets/images/signup_deriv.png";

const SignUp = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  const handleDerivOAuth = () => {
    const appId = process.env.REACT_APP_DERIV_APP_ID || '64284'; // Fallback to default if not set

    // Deriv will redirect to the callback URL configured in your Deriv app settings
    // The callback URL should be: https://your-site.netlify.app/.netlify/functions/oauth-callback
    window.location.href =
      `https://oauth.deriv.com/oauth2/authorize?app_id=${appId}&platform=web`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-100">
      <div className="w-full max-w-lg bg-white rounded-lg shadow-md p-6 text-center lg:max-w-2xl">
        <img
          src={signupImage}
          alt="Sign up on Deriv"
          className="mx-auto mb-6 w-3/4 sm:w-1/2 md:w-1/3 lg:w-1/4"
        />

        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4">
          Sign Up
        </h1>

        <p className="mb-6 text-gray-700 text-base sm:text-lg lg:text-xl">
          Please sign in to your Deriv account to link it to your 8gg App.
        </p>

        <button
          onClick={handleDerivOAuth}
          className="w-full py-3 bg-teal-600 text-white rounded-md text-lg font-semibold hover:bg-teal-700 transition"
        >
          Continue to Deriv
        </button>
      </div>

      <button
        onClick={() => navigate("/signin")}
        className="mt-6 text-teal-600 text-lg sm:text-xl font-semibold hover:text-teal-800 transition"
      >
        Back to Sign In
      </button>
    </div>
  );
};

export default SignUp;
